module.exports = __webpack_public_path__ + "static/img/model-bg26.76d7c0e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/model-bg26.jpg
// module id = vf52
// module chunks = 0